export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13326.e7d06330.jpg";